export default "__VITE_ASSET__KBJEi_UR__"